import React from 'react';

/**
 * Two hairline vertical guides running the full height of the page, sitting on the
 * content margins (24px on phones, 26px on desktop) — a quiet architectural frame.
 * Fixed and non-interactive; a mid-grey tone keeps them faint on the white page,
 * the dark hero and the black footer alike.
 */
export function PageGuides() {
  return <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-40" data-id="element-290" data-mp="1vf1hkzxz60k3">
      <span className="absolute inset-y-0 left-[var(--guide)] w-px bg-[rgb(128_128_128/0.22)]" data-id="element-291" data-mp="17pgwobi9gt86" />
      <span className="absolute inset-y-0 right-[var(--guide)] w-px bg-[rgb(128_128_128/0.22)]" data-id="element-292" data-mp="13odhzsby938j" />
    </div>;
}